<template>
  <div id="thumbnail-slider">
    <div class="thumbnail-slider-action" v-if="is_display_action" @click="showPrevSlide"><i class="fa fa-chevron-left"></i></div>
    <div class="thumbnail-slide">
      <div id="thumbnail-container" ref="thumbnailSlider">
        <div class="thumbnail-item" v-for="(image, index) in images" :key="index" :class="{'active' : index === ClickedIndex}">
          <img :src="image.image_base_path+image.path" alt="Thumbnail" @error="setPrebuildThumbnail($event)" @click="updateMainImage(index)">
        </div>
        <div class="thumbnail-item" :class="{'active' : images.length === ClickedIndex}" v-if="euTyreLabelImageSrc != ''">
          <img :src="euTyreLabelImageSrc" alt="EuTyreLabelImage" @click="updateMainImage(images.length)">
        </div>
      </div>
    </div>
    <div class="thumbnail-slider-action" v-if="is_display_action" @click="showNextSlide"><i class="fa fa-chevron-right"></i></div>
  </div>
</template>

<script>

export default  {
  name : "ThumbnailSliderProductDetail",
  props : {
    images : { default: () => []},
    euTyreLabelImageSrc : {default: () => ''},
    newClickedIndex : { default: () => 0},
  },
  computed : {
    is_display_action() {
      return (this.images.length + (this.euTyreLabelImageSrc != '' ? 1 : 0)) > 3
    }
  },
  watch : {
    newClickedIndex : {
      handler(newVal) {
        this.ClickedIndex = newVal
      }
    }
  },
  data() {
    return {
      ActiveIndex : 0,
      ClickedIndex : 0,
      slideWidth: 85,
      windowInnerWidth : window.innerWidth
    }
  },
  methods : {
    updateMainImage(index) {
      this.ClickedIndex = index;
      this.$emit('evtActiveSlideFromThumbnail', index)
    },
    showSlide() {
      const translateValue = -this.ActiveIndex * (this.slideWidth) + 'px';
      this.$refs.thumbnailSlider.style.transform = 'translateX(' + translateValue + ')';
    },
    showNextSlide() {
      if (this.ActiveIndex < this.images.length - 2) {
        this.ActiveIndex++;
        this.showSlide();
      } else {
        this.ActiveIndex = 0;
        this.showSlide();
      }
    },
    showPrevSlide() {
      if (this.ActiveIndex > 0) {
        this.ActiveIndex--;
        this.showSlide();
      }
    },
    doResponsive() {
      this.windowInnerWidth = window.innerWidth
      if (this.windowInnerWidth <= 280) {
        this.slideWidth = 55
      } else {
        this.slideWidth = 85
      }
    }
  },
  mounted() {
    this.showSlide()
    this.doResponsive()
    var that = this
    window.addEventListener('resize', () => {
      that.doResponsive()
    })
  }
}
</script>

<style scoped>
#thumbnail-slider {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  background: #f8f9fa !important;
}
#thumbnail-slider .thumbnail-slider-action {
  cursor: pointer;
  color: rgba(0,0,0,0.5);
  transition: 1s;
}

#thumbnail-slider .thumbnail-slider-action:hover {
  transform: scale(1.02);
}
.thumbnail-slide {
  width: 255px;
  overflow-x: hidden;
  margin: 0 .5rem;
}
#thumbnail-container {
  display: flex;
  transition: transform 0.5s ease-in-out;
  max-width: 100%;
  margin: .5rem auto;
}
#thumbnail-container .thumbnail-item {
  width: 80px;
  height: 80px;
  border: 1px solid #CCCCCC;
  justify-content: center;
  display: flex;
  background: #ffffff;
  position: relative;
  overflow: hidden;
  flex: 0 0 80px;
  box-sizing: border-box;
  margin-right: 5px;
}
#thumbnail-container .thumbnail-item.active {
  box-shadow: 0px 0px 10px rgba(0,0,0,0.5);
}

#thumbnail-container .thumbnail-item img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 100%;
  max-height: 100%;
  transition: transform 0.3s ease-in-out;
}

@media (max-width: 280px) {
  .thumbnail-slide {
    width: 165px;
  }

  #thumbnail-container .thumbnail-item {
    width: 50px;
    height: 50px;
    flex: 0 0 50px;
    margin-right: 5px;
  }
}
</style>